<template>
  <div id="LeftNav">
    <mu-paper class="left_nav"
              :style="{width: $store.getters.sidebar.opened ? '200px': '72px'}">
      <mu-flex direction="column"
               justify-content="between"
               style="height:100%;">
        <el-menu :default-active="$route.path"
                 class="nav_bar"
                 router
                 :collapse="isCollapse"
                 unique-opened>
          <template v-for="item in routers">
            <el-menu-item :index="item.path + '/' + item.children[0].path" :key="item.name" v-if="!item.hidden">
              <mu-icon :value="item.meta.icon" :size="18"></mu-icon>
              <span slot="title">{{item.meta.title}}</span>
            </el-menu-item>
          </template>
        </el-menu>
        <mu-flex direction="column"
                 align-items="center"
                 style="padding-left:16px;">
          <span class="remark_title"
                v-if="isCollapse">感知数据中心</span>
          <mu-button icon
                     small
                     color="#6B75A0"
                     class="expand_btn"
                     @click="toggleSideBar">
            <mu-icon :value="!isCollapse? 'format_indent_decrease':'format_indent_increase'"
                     style="color:#6B75A0 !important;"
                     :size="24"></mu-icon>
          </mu-button>
        </mu-flex>
      </mu-flex>
    </mu-paper>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import watermarkPic from '@/assets/image/pic_watermark.png';
import store from '@/vuex/store'
export default {
  name: "LeftNav",
  data () {
    return {
      watermarkPic: watermarkPic
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  created () {
    this.dictForm = window.dict;
    console.log(this.routes);
    this.alarmCount = store.state.alarmCount;
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  },
  watch: {
    alarmCount (newVal) {
      this.$forceUpdate();
    }
  }
}
</script>
<style scoped>
.left_nav {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  height: 100vh;
  padding-top: 28px;
  padding-bottom: 16px;
  overflow: auto;
  background: #191b2f;
  box-shadow: rgba(0, 0, 0, 0.4) 4px 0px 8px;
}
.brand {
  width: 100%;
  padding: 32px 24px;
}
.brand img {
  width: 100%;
  height: auto;
}
.brand .title {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  font-family: "DINCOND";
}
.remark_title {
  color: #6b75a0;
  font-size: 16px;
  transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  position: absolute;
  bottom: 160px;
  width: 220px;
  height: 22px;
}
@media (max-height: 860px) {
  .remark_title {
    display: none;
  }
  .expand_btn {
    display: none;
  }
}
@media (min-height: 860px) {
  .remark_title {
    display: inline-block;
  }
  .expand_btn {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/leftNav.vue